import React, { useState } from "react";

const useBookingSourcePerformance = ({ data, period, comparisonData }) => {
  const [metric, setMetric] = useState("Revenue");
  const handleMetricChange = (val) => {
    setMetric(val);
  };

  const yAxisKey = "bookingSource";
  const xAxisKey = (() => {
    let key = "";
    switch (metric.toLowerCase()) {
      case "revenue":
        key = "revenue";
        break;
      case "rooms sold":
        key = "roomsSold";
        break;
      default:
        key = "revenue";
        break;
    }
    return key;
  })();

  const getChartData = (data) => {
    let formattedData = [];
    switch (period.toLowerCase()) {
      case "today":
        formattedData =
          data?.groupSourceWiseMetricsBreakdown?.tdGroupSourceWiseMetrics || [];
        break;
      case "mtd":
        formattedData =
          data?.groupSourceWiseMetricsBreakdown?.mtdGroupSourceWiseMetrics ||
          [];
        break;
      case "ytd":
        formattedData =
          data?.groupSourceWiseMetricsBreakdown?.ytdGroupSourceWiseMetrics ||
          [];
        break;
      default:
        break;
    }
    formattedData.sort((a, b) => b[xAxisKey] - a[xAxisKey]);
    return formattedData;
  };
  const chartData = getChartData(data);
  const comparisonChartData = getChartData(comparisonData);

  const mergedChartData = chartData.map((item) => {
    const comparisonItem = comparisonChartData.find(
      (comp) => comp.bookingSource === item.bookingSource
    );

    const prefixedComparisonData = comparisonItem
      ? Object.fromEntries(
          Object.entries(comparisonItem).map(([key, value]) => [
            `ly_${key}`,
            value,
          ])
        )
      : {};

    return {
      ...item,
      ...prefixedComparisonData,
    };
  });

  return {
    metric,
    handleMetricChange,
    mergedChartData,
    xAxisKey,
    yAxisKey,
    chartData,
    mergedChartData,
  };
};

export default useBookingSourcePerformance;
